import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AccountsGroupPrefComponent } from 'src/app/accounts-group-pref/accounts-group-pref.component';
import { APIService } from './../api.service';
import { CommonService } from '../services/common.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { CfgGstLedgersComponent } from '../cfg-gst-ledgers/cfg-gst-ledgers.component';

@Component({
  selector: 'app-accounts-settings',
  templateUrl: './accounts-settings.component.html',
  styleUrls: ['./accounts-settings.component.scss']
})
export class AccountsSettingsComponent implements OnInit {

  constructor(private dialog: MatDialog, private modalService: NgbModal, private apiService: APIService, private commonService: CommonService, private SpinnerService: NgxSpinnerService) { }


  heads: any;
  selectedCon: string = "";
  closeResult: any;
  modalReference: any;
  modalStage: any;
  mdlRef: any;
  cookieValue: any;
  jarvisData: any = [];
  agencyData: any = [];
  right: any;
  selectedFirstFY: any;
  financialYears: any = [];
  financialYearsList: any = [];
  ERP_Agn: Array<any> = [];
  acctStartDT: Date = new Date();

  ngOnInit(): void {
    let tmpERP_Agn = this.apiService.getCookie("ERP_Agn");
    if (tmpERP_Agn) {
      this.ERP_Agn = JSON.parse(tmpERP_Agn);
    }

    if (this.ERP_Agn.length > 0) {
      this.acctStartDT = new Date(this.ERP_Agn[0].AccountStartDT);
    }
    this.right = this.apiService.getCookie("J");
    if (this.right) {
      this.right = JSON.parse(this.right);
    }
    if(!this.right[0].AcctsCfg) {
      window.location.href = this.apiService.fn_isLiveURL() ? "https://biziverse.com/main.html#/home" : "http://localhost:62854/main.html#/home";
    }

    let cookieValue = this.apiService.getCookie('Heads'); // Retrieve the cookie
    if (cookieValue) {
      this.heads =  JSON.parse(cookieValue);
    }
    var jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }
    let agencyData = this.apiService.getCookie("M");
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
    }
    this.financialYears = this.commonService.checkFinancialYear(this.acctStartDT, new Date());
    this.financialYearsList = this.commonService.checkFinancialYear(new Date('2020-04-01'), new Date());
    this.selectedFirstFY = this.financialYears[0].FY;
  }

  open(context: string) { 
    this.modalReference = this.modalService.open(AccountsGroupPrefComponent, { windowClass: "GrpModal" ,ariaLabelledBy: 'modal-basic-title',  backdrop: 'static', keyboard: false });
    this.modalReference.componentInstance.mdlRef = this.modalReference;  
    this.modalReference.componentInstance.context = context;
  }

  openGSTLedgerModal() {
    this.modalService.open(CfgGstLedgersComponent, { 
      windowClass: "gstSelectModal", 
      backdrop: 'static', 
      keyboard: false 
    });
  }


  backBtn() {
    window.history.back();
  }
}
